import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import Breadcrumbs from '../components/Breadcrumbs';
import { comparisons } from '../data/comparisons';
import { combineSchemas, organizationSchema, breadcrumbSchema } from '../lib/schema';
import { ArrowRight } from 'lucide-react';

const ComparisonHub = () => (
  <Layout>
    <SEO
      title="Custom Web Design vs Website Builders | Honest Comparisons | Website Symphony"
      description="Honest side-by-side comparisons of custom web design vs Wix, Squarespace and WordPress. Pick the right route for your business."
      canonical="/compare"
      schema={combineSchemas(organizationSchema, breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Comparisons', path: '/compare' }]))}
    />
    <Breadcrumbs items={[{ name: 'Comparisons', path: '/compare' }]} />
    <section className="py-16 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h1 className="text-[#2C5F66] text-3xl md:text-5xl font-extrabold">Custom Web Design vs the Alternatives</h1>
        <p className="text-gray-600 mt-4 text-lg max-w-3xl">Honest, side-by-side comparisons of custom web design against the most popular DIY website builders. No fluff, no sales pitch — just the truth.</p>

        <div className="grid md:grid-cols-3 gap-6 mt-12">
          {Object.values(comparisons).map((c) => (
            <Link key={c.slug} to={`/compare/${c.slug}`} className="group bg-[#F7F7F5] rounded-lg p-7 hover:shadow-xl hover:-translate-y-1 transition-all">
              <span className="inline-block bg-[#D9A04A] text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider">Comparison</span>
              <h2 className="mt-4 text-[#2C5F66] text-xl font-bold group-hover:text-[#D9A04A] transition-colors">Custom vs {c.competitor}</h2>
              <p className="mt-2 text-gray-600 text-sm line-clamp-3">{c.intro}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-[#2C5F66] font-semibold text-sm group-hover:text-[#D9A04A]">Read comparison <ArrowRight size={14} /></span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  </Layout>
);

export default ComparisonHub;
